import * as React from 'react';
import { SVGProps } from 'react';

const IconWideScreenFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h5v1H5v2h6v-2H9v-1h5a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2Z"
    />
  </svg>
);
export default IconWideScreenFilledSizeS;
